import styled from 'styled-components'

import { Grid } from 'mf-ui-components'

export const Container = styled(Grid).attrs({
  flow: 'row',
  gap: 'lg',
  alignItems: 'center',
  justifyContent: 'space-evenly',
})``
